
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import RouteChangeTracker from './components/RouteChangeTracker';
import Home from './pages/Home';
import { ColorModeProvider } from './ColorModeContext';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Services = lazy(() => import('./pages/Services'));
const About = lazy(() => import('./pages/About'));
const Quote = lazy(() => import('./pages/Quote'));
const Faq = lazy(() => import('./pages/Faq'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const NotFound = lazy(() => import('./pages/NotFound'));

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <SwitchTransition>
      <CSSTransition
        key={location.key}
        classNames="fade"
        timeout={100}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </CSSTransition>
    </SwitchTransition>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ColorModeProvider>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}>
          <Router>
            <RouteChangeTracker />
            <Header />
            <main style={{ flexGrow: 1, padding: '20px 16px', overflowX: 'hidden' }}>
              <Suspense fallback={null}>
                <AnimatedRoutes />
              </Suspense>
            </main>
            <Footer />
            <StickyCTA />
          </Router>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
        </div>
      </ColorModeProvider>
    </HelmetProvider>
  );
}

export default App;
